import { render, staticRenderFns } from "./FlightsHeroSlogan.vue?vue&type=template&id=0246ffcd"
import script from "./FlightsHeroSlogan.vue?vue&type=script&lang=js"
export * from "./FlightsHeroSlogan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports